import clsx from 'clsx';
import React from 'react';
import { Badge } from '../Badge';
import { Box } from '../Box';
export function TimelineItem(props) {
    const { children, status = 'default', variant, className, ...rest } = props;
    const badgeVariant = {
        default: 'neutral',
        pending: 'warning',
        success: 'positive',
        failed: 'negative',
    }[status];
    return (React.createElement(Box.Restricted, { ...rest, elementType: "li", className: clsx('mollie-ui-timeline-item', {
            [`mollie-ui-timeline-item--${variant}`]: variant,
        }, className) },
        React.createElement("div", { className: "mollie-ui-timeline-border", "aria-hidden": "true" },
            React.createElement("span", { className: "mollie-ui-timeline-border-start" }),
            React.createElement(Badge, { size: "small", variant: badgeVariant, className: "mollie-ui-timeline-badge" }),
            React.createElement("span", { className: "mollie-ui-timeline-border-end" })),
        React.createElement("div", { className: "mollie-ui-timeline-label" }, children)));
}
TimelineItem.displayName = 'Timeline.Item';
//# sourceMappingURL=TimelineItem.js.map